import classNames from "clsx";
import { useTranslations } from "next-intl";

import { Badge, Text } from "@shared/elements";
import { useAdImpressionTracking } from "@shared/tracking";
import { AdTrackingTag } from "@shared/types";

import { AdTrackingTags } from "./AdTrackingTags";
import { MESSAGE_PREFIX } from "./constants";

type AdCardProps = {
  className?: string;
  title: string;
  campaign: string;
  src: string;
  poster?: string;
  type: "video" | "image";
  clickUrl: string;
  impressionUrl: string;
  trackingTags: AdTrackingTag[] | null;
};

export default function AdCard({
  className,
  title,
  src,
  poster,
  type,
  campaign,
  impressionUrl,
  clickUrl,
  trackingTags,
  ...rest
}: AdCardProps) {
  const t = useTranslations(`${MESSAGE_PREFIX}AdCard`);
  const ref = useAdImpressionTracking({
    impressionUrl: impressionUrl,
  });

  return (
    <div
      className={classNames(
        "h-full flex flex-col justify-between relative",
        className,
      )}
      {...rest}
    >
      <a href={clickUrl} ref={ref} target="_blank" rel="noopener noreferrer">
        <div className="block aspect-w-4 aspect-h-3 w-full overflow-hidden mb-4 shadow-md">
          {type === "image" ? (
            /* eslint-disable-next-line @next/next/no-img-element */
            <img src={src} className="object-cover" alt={campaign} />
          ) : (
            /* eslint-disable-next-line jsx-a11y/media-has-caption */
            <video autoPlay muted playsInline loop poster={poster}>
              <source src={src} type="video/mp4" />
            </video>
          )}
        </div>
        <div className="flex items-center justify-between mb-3">
          <Badge color="primary" size="xs">
            {t("badge")}
          </Badge>
        </div>
        <Text as="h2" size="lg" weight="medium" className="mb-2">
          {title}
        </Text>
      </a>
      <AdTrackingTags trackingTags={trackingTags} />
    </div>
  );
}

AdCard.messages = [`${MESSAGE_PREFIX}AdCard`];
